module.exports = __webpack_public_path__ + "static/img/jindu_back.615e3a8.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/jindu_back.png
// module id = yO0g
// module chunks = 0